import { render, staticRenderFns } from "./DonationPaymentSms.vue?vue&type=template&id=150f65a8&"
import script from "./DonationPaymentSms.vue?vue&type=script&lang=js&"
export * from "./DonationPaymentSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports